<template>
  <div class="sample_render">
    <div class="sample_text"><v-icon>link</v-icon>샘플 페이지</div>
    <div class="items_wrapper">
      <div class="box1">
        <!-- <div class="link_txt">
          <span>VIDEO</span>
        </div> -->
        <div class="link_txt">
          <a :href="ipUrl" :title="ipmsg" target="_blank">
            <span>PC 풀스크린</span>
          </a>
        </div>
        <div class="link_txt">
          <a :href="pcIpSkinUrl" :title="ipSkinPc" target="_blank">
            <span>PC 브랜드플러스</span>
          </a>
        </div>
        <div class="link_txt">
          <a :href="ipPerformancePc" :title="ipPerformancePcmsg" target="_blank">
            <span>PC 퍼포먼스</span>
          </a>
        </div>
        <div class="link_txt">
          <a :href="ipShortsPc" :title="ipShortsPcmsg" target="_blank">
            <span>PC 숏츠</span>
          </a>
        </div>
        <div class="link_txt">
          <a :href="ipSavePc" :title="ipShortsPcmsg" target="_blank">
            <span>PC Save</span>
          </a>
        </div>

      </div>

      <div class="box2">
        <!-- <div class="link_txt">
          <span>Display AD</span>
        </div> -->
        <div class="link_txt">
          <!-- <a :href="mipUrl" :title="mipmsg" target="_blank"> -->
          <a href="#" :title="mipmsg" @click="test($event)">
            <span>MO 풀스크린</span>
          </a>
        </div>
        <div class="link_txt">
          <a href="#" :title="nhbamsg" @click="moBrandUpCheck($event)">
            <span>MO 브랜드플러스</span>
          </a>
        </div>
                <div class="link_txt">
          <!-- <a :href="mipUrl" :title="mipmsg" target="_blank"> -->
          <a href="#" :title="ipPerformanceMomsg" @click="ohipPerformanceMo($event)">
            <span>MO 퍼포먼스</span>
          </a>
        </div>
        <div class="link_txt">
          <a href="#" :title="ipShortsMomsg" @click="ohipShortsMo($event)">
            <span>MO 숏츠</span>
          </a>
        </div>
        <div class="link_txt">
          <a href="#" :title="ipSaveMomsg" @click="ohipSaveMo($event)">
            <span>MO Save</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as url from '@/assets/links'
  import {isMobile} from '@/assets/func'

  export default {
    name: 'samplePage',
    data () {
      return {
        isMobile: false,
        ipmsg: 'PC 인터플레이 보러가기',
        mipmsg: '모바일 인터플레이 보러가기',
        ippmsg: '인터플레이 세로형 보러가기',
        nbamsg: 'PC 네이티브 보러가기',
        nhbamsg: '모바일 네이티브 보러가기',
        ipSkinPc: 'PC 인터플레이스킨 보러가기',
        ipShortsPcmsg: 'PC 쇼츠 보러가기',
        ipPerformancePcmsg: 'PC 퍼포먼스 보러가기',
        ipShortsMomsg: '모바일 쇼츠 보러가기',
        ipPerformanceMomsg: '모바일 퍼포먼스 보러가기',
        ipSaveMomsg: '모바일 Save 보러가기'
      }
    },
    computed: {
      ipUrl () {
        return url.ipUrl
      },
      mipUrl () {
        return url.mipUrl
      },
      isUrl () {
        return url.isUrl
      },
      ipPlusUrl () {
        return url.ipPlusUrl
      },
      pcNativeUrl () {
        return url.nbaUrl
      },
      moNativeUrl () {
        return url.nhbaUrl
      },
      moBrandUpUrl () {
        return url.ohipBrandUp
      },
      pcIpSkinUrl () {
        return url.ipSkinPc
      },
      ipPerformancePc () {
        return url.ipPerformancePc
      },
      ipPerformanceMo () {
        return url.ipPerformanceMo
      },
      ipShortsPc () {
        return url.ipShortsPc
      },
      ipShortsMo () {
        return url.ipShortsMo
      },
      ipSavePc () {
        return url.ipSavePc
      },
      ipSaveMo () {
        return url.ipSaveMo
      }
    },
    methods: {
      test (e) {
        if (!this.isMobile) {
          alert('이 페이지는 모바일에 최적화 되어있습니다. 모바일 기기에서 확인해주세요.')
        }
        window.open(this.mipUrl, '_newtab')
      },
      moNativeCheck (e) {
        if (!this.isMobile) {
          alert('이 페이지는 모바일에 최적화 되어있습니다. 모바일 기기에서 확인해주세요.')
        }
        window.open(this.moNativeUrl, '_newtab')
      },
      moBrandUpCheck (e) {
        if (!this.isMobile) {
          alert('이 페이지는 모바일에 최적화 되어있습니다. 모바일 기기에서 확인해주세요.')
        }
        window.open(this.moBrandUpUrl, '_newtab')
        return
      },
      ohipShortsMo (e) {
        if (!this.isMobile) {
          alert('이 페이지는 모바일에 최적화 되어있습니다. 모바일 기기에서 확인해주세요.')
        }
        window.open(this.ipShortsMo, '_newtab')
        return
      },
      ohipPerformanceMo (e) {
        if (!this.isMobile) {
          alert('이 페이지는 모바일에 최적화 되어있습니다. 모바일 기기에서 확인해주세요.')
        }
        window.open(this.ipPerformanceMo, '_newtab')
        return
      },
      ohipSaveMo (e) {
        if (!this.isMobile) {
          alert('이 페이지는 모바일에 최적화 되어있습니다. 모바일 기기에서 확인해주세요.')
        }
        window.open(this.ipSaveMo, '_newtab')
        return
      }
    },
    created () {
      this.isMobile = isMobile()
    }
  }
</script>

<style scoped>
  .items_wrapper {
    width: calc(100% - 10px);
    margin: 0 auto;
    padding-bottom: 5px;
  }
  .sample_text {
    margin-left: 10px;
    height: 30px;
    line-height: 30px;
    color: #689f38;
    font-weight: 500;
  }
  i {
    vertical-align: middle;
    margin-right: 5px;
    color: #689f38;
  }
  .link_txt {
    height: 25px;
    line-height: 25px;
    vertical-align: middle;
    display: inline-block;
    padding-top: 5px;
    margin-left: 15px;
  }
  .link_txt a {
    color: #689f38;
  }
</style>



// WEBPACK FOOTER //
// SamplePage.vue?47d1932a